import { ProductType, RegisterMode, isKorpoRegisterMode, isTransferRegisterMode } from 'cart-model';
import { useHistory } from 'common-react';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { logSelectRetirementType } from '../../model/events';
import ProductWizardState from '../../model/ProductWizardState';
import { productWizardActions } from '../../model/store';
import Screen from '../ProductWizard/Screen';
import { ProductWizardTransLink } from '../ProductWizardTransLink/ProductWizardTransLink';
import { Typography, Button, ModalDialog, InlineButton } from 'ui-components';

import useStyles from './IkeOrIkzeMobileChooseDialog.style';

const IkeOrIkzeMobileChooseDialog: React.FC<{ open: boolean, onClose: () => void, selectedProductType: ProductType | undefined }> = ({
                                                                                                                                       open,
                                                                                                                                       onClose,
                                                                                                                                       selectedProductType}) => {
  const { t } = useTranslation('ike-or-ikze');
  const [urlT] = useTranslation('url');
  const history = useHistory(urlT);
  const c = useStyles({});
  const dispatch = useDispatch();
  const currentRegisterMode = useSelector((state: ProductWizardState) => state.cartState.registerMode);
  const isCurrentCartKorpo = isKorpoRegisterMode(currentRegisterMode);
  const isCurrentCartTransfer = isTransferRegisterMode(currentRegisterMode);
  const setProductType = (value: ProductType, registerMode: RegisterMode) => {
    dispatch(productWizardActions.setProductType(value));
    if (isCurrentCartKorpo || isCurrentCartTransfer) {
      dispatch(productWizardActions.clearCart());
    }
    dispatch(productWizardActions.setKorpoData(undefined));
    dispatch(productWizardActions.setTransferInstitutionName(undefined));
    dispatch(productWizardActions.setSelectedTypeOfInvestment({ selectedTypeOfInvestment: value }));
    dispatch(productWizardActions.setRegisterMode(registerMode));
  };

  if (selectedProductType == null) {
    return null;
  }

  const ikeSectionContent = (
      <>
          <ProductWizardTransLink
            path={Screen.SELECT_PATH.code}
            className={c.productWizardTransLink}
            onClick={() => {
              setProductType(ProductType.ike, RegisterMode.OPEN);
              logSelectRetirementType();
            }}>
              <Button buttonType="primary" className={c.chooseButton} tabIndex={-1} component="span">
                {t('ike.button_mobile_label')}
              </Button>
          </ProductWizardTransLink>
          <ProductWizardTransLink
            path={Screen.TRANSFER_IKE.code}
            className={c.productWizardTransLink}
            onClick={() => {
              setProductType(ProductType.ike, RegisterMode.TRANSFER);
              logSelectRetirementType();
            }}>
              <Button buttonType="primary" className={c.chooseButton} tabIndex={-1} component="span">
                {t('ike.transfer_button_label')}
              </Button>
          </ProductWizardTransLink>
        <span className={c.ikeIkzeKorpoLabel}>
          {t('ike.korpo_mobile_label')}
        </span>
        <InlineButton
          variant="underline"
          onClick={() => {
            setProductType(ProductType.ike, RegisterMode.OPEN_KORPO);
            logSelectRetirementType();
            history.push(Screen.OPEN_IKE_KORPO.code);
          }}>
          {t('ike.korpo_button_label')}
        </InlineButton>
      </>
  );

  const ikzeSectionContent = (
      <>
          <ProductWizardTransLink
              path={Screen.SELECT_PATH.code}
              className={c.productWizardTransLink}
              onClick={() => {
                setProductType(ProductType.ikze, RegisterMode.OPEN);
                logSelectRetirementType();
              }}>
            <Button buttonType="primary" className={c.chooseButton} tabIndex={-1} component="span">
              {t('ikze.button_mobile_label')}
            </Button>
          </ProductWizardTransLink>
          <ProductWizardTransLink
              path={Screen.TRANSFER_IKZE.code}
              className={c.productWizardTransLink}
              onClick={() => {
                setProductType(ProductType.ikze, RegisterMode.TRANSFER);
                logSelectRetirementType();
              }}>
            <Button buttonType="primary" className={c.chooseButton} tabIndex={-1} component="span">
              {t('ikze.transfer_button_label')}
            </Button>
          </ProductWizardTransLink>
        <span className={c.ikeIkzeKorpoLabel}>
          {t('ikze.korpo_mobile_label')}
        </span>
        <InlineButton
          variant="underline"
          onClick={() => {
            setProductType(ProductType.ikze, RegisterMode.OPEN_KORPO);
            logSelectRetirementType();
            history.push(Screen.OPEN_IKZE_KORPO.code);
          }}>
          {t('ikze.korpo_button_label')}
        </InlineButton>
      </>
  );

  return (
      <ModalDialog
        className={c.root}
        mobileVariant="drawer"
        titleVisuallyHidden={true}
        open={open}
        onClose={onClose}
        size="md"
        icon={null}
        title={
          selectedProductType === ProductType.ike
            ? t('ike-drawer-title')
            : t('ikze-drawer-title')
        }
        content={
          <div className={c.contentWrapper}>
            <Typography variant="body1">
              {selectedProductType === ProductType.ike
                  ? ikeSectionContent
                  : ikzeSectionContent}
            </Typography>
          </div>
        }
      />
  );
};

export default IkeOrIkzeMobileChooseDialog;
